export default {
  error: { id: 'error' },
  notFoundMessage: { id: 'not_found_message' },
  goBack: { id: 'go_back' },
  accessDeniedMessage: { id: '403_error_message' },
  accessGoBack: { id: '403_go_back' },
}
